import React from 'react';

const intersectionObserverPolyfill = () => import('intersection-observer');

export const useIntersecting = (
    selector: HTMLElement | null,
    rootMargin = '400px',
) => {
    const observerRef = React.useRef(null);
    const [isIntersecting, setIsIntersecting] = React.useState(false);

    React.useEffect(() => {
        let observerNode =
            observerRef.current as unknown as IntersectionObserver;

        const loadIntersectionObserver = async () => {
            if (selector) {
                await intersectionObserverPolyfill();
                const onIntersection = (
                    entries: IntersectionObserverEntry[],
                ) => {
                    if (entries[0].intersectionRatio <= 0) return;

                    setIsIntersecting(true);
                    observerNode.disconnect();
                };
                observerNode = new IntersectionObserver(onIntersection, {
                    rootMargin,
                });

                observerNode.observe(selector);
            }
        };

        loadIntersectionObserver();

        return () => {
            observerNode.disconnect();
        };
    }, [selector, isIntersecting, rootMargin]);

    return [isIntersecting];
};
